export default "__VITE_ASSET__fa32712f__"